import { useCallback, useEffect, useState } from 'react';

const useCopyToClipboard = (
  text: string,
  inputRef: React.RefObject<HTMLInputElement & HTMLTextAreaElement>,
) => {
  const copyToClipboard = (ref: React.RefObject<HTMLInputElement & HTMLTextAreaElement>) => {
    ref?.current?.select();
    const success = document.execCommand('copy');
    return success;
  };

  const [copied, setCopied] = useState(false);

  const copy = useCallback(() => {
    setCopied(copyToClipboard(inputRef));
  }, [inputRef]);

  useEffect(() => () => setCopied(false), [text]);

  const resetCopy = useCallback(() => {
    setCopied(false);
  }, []);

  return [copied, copy, resetCopy] as const;
};

export default useCopyToClipboard;
